<template>
    <section class="p-2">
        <div class="d-flex flex-wrap align-items-center mt-0 mx-2 justify-content-between w-100 page-heading">
            <div>
                <div v-if="activeLink" class="d-flex align-items-center">
                    <div class="">
                        <div v-if="sidebarIcon" 
                        v-html="sidebarIcon" class="icon-container">
                        </div>
                    </div>
                    <div>
                        <router-link :to="activeLink">
                            <h3 class="mb-0 mr-2 p-0 d-inline-block" v-html="title"></h3>
                            <div v-if="subtitle" id="page-heading-subtitle" class="text-secondary mb-2" style="font-size:1.1rem" v-html="subtitle"></div>
                        </router-link>
                        <div style="max-width:600px;"><slot name="subtitle"></slot></div>
                    </div>
                </div>
            </div>
            <slot></slot>
            <div v-if="primaryLinkTo || secondaryLinkTo">
                <router-link 
                class="btn btn-secondary ml-auto mr-1" 
                :to="{name: secondaryLinkTo}" 
                v-if="secondaryLinkTo">
                    <i class="fa fa-arrow-left mr-1"></i> {{secondaryText || 'Go Back'}}
                </router-link>
                <router-link 
                class="btn btn-primary" 
                :class="{'ml-auto': !secondaryLinkTo && !noMargin }" 
                :to="{name: primaryLinkTo}" 
                v-if="primaryLinkTo">
                    <i class="fa fa-plus mr-1"></i> {{primaryText || 'New'}}
                </router-link>
            </div>
        </div>
    </section>
</template>

<script>
    import SchoolContractSelector from '../../components/SchoolContractSelector'

    export default {
        props: {
            'title': {
                default: 'NO TITLE',
                type: String
            },
            subtitle: null,
            'primaryLinkTo': {
                default: null,
            },
            'secondaryLinkTo': {
                default: '',
                type: String
            },
            'primaryText': {
                default: null,
            },
            'secondaryText': {
                default: null,
            },
            'noMargin': {
                default: false,
                type: Boolean
            },
            'pContractRequired': {
                default: false,
                type: Boolean
            },
        },

        components: {
            SchoolContractSelector
        },

        data() {
            return {
                sidebarIcon: null,
                contractRequired: this.pContractRequired,
                activeLink: null,
                // contractSelected: (localStorage.getItem('contractSelected') && typeof localStorage.getItem('contractSelected') !== undefined) ? JSON.parse(localStorage.getItem('contractSelected')) : null,
            }
        },

        mounted() {
            let self = this;
            this.pageHeadingIcon();

            this.$nextTick(function() {
                self.getActiveLink();
            });
        },

        methods: {
            pageHeadingIcon() {
                var self = this
                setTimeout( function() {
                    if (!$(".router-active i")[0]) return;
                    var el = document.querySelector('.router-active .nav-icon').cloneNode()
                    if (el) {
                        el.classList.add("font-3xl")
                    }
                    let pageIcon = el ? el.outerHTML : null;
                    self.sidebarIcon = pageIcon ? pageIcon : '';
                }, 500);
            },

            getActiveLink() {
                let activeLink = $(".router-active")[0];
                if (!activeLink) {
                    this.activeLink = '#';
                    return;
                }

                try {
                    //let baseUrl = window.location.host;
                    var baseUrl = this.$route.path;
                    this.activeLink = activeLink.replace(baseUrl,'').replace("https://",'').replace('http://','');
                } catch(err) {
                    this.activeLink = "#";
                }
            }
        },

        watch: {
            '$route.path': function() {
                this.getActiveLink();
            }
        }
    }
</script>

<style lang="scss" scoped>

    .contract-notify {
        cursor: pointer;
        box-shadow: 0 0 1px 0 rgba(51,101,115,0.1);
        transition: box-shadow 500ms;

        &:hover {
            box-shadow: 0 3px 8px 1px rgba(51,101,115,0.3);
        }
    }

    @media (min-width: 991.98px) {
        section {
            margin-top: 0;
        }
    }

    h3 {
        font-weight: 500;
        color: var(--gray-900);
        font-size: 1.9rem;
    }

    .icon-container {
        width: 52px;
        height: 52px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 100%;
        background: var(--gray-300);
        margin: 0 10px 0 0;
    }
</style>

